
<!-- Lobby Head -->
<div class="lobby_group--banner" *ngIf="allGamesPage"
    [ngClass]="isUserLoggedIn && !allGamesPage ? 'lobby_group--home-banner' : ''">
    <app-lobby-filter-group [categoryType]="selectedCategoryType" [lobbyDetails]="lobbyDetails"
        [showTabsList]="showTabsList" [currentGameGroupsList]="currentGameGroupsList" [gameProviderMap]="gameProviderMap"></app-lobby-filter-group>
</div>
<div [ngClass]="allGamesPage ? 'game__lobby--deposit' : ''" *ngIf="isUserLoggedIn && showBannerOnlyHomePage">
    <app-homebanner [isHideCommonHeader]="isHideCommonHeader"></app-homebanner>
</div>

<!-- Lobby Body -->
<div class="container-p9 lobby_group"
    [ngClass]="showSwiper && !showAllGames && !showAllProviders ? 'lobby_group--allgames-swiper' : 'lobby_group--allgames'">
    <!-- Skelton loader -->
    <div class="lobby_group--row skelton_loader clearfix" *ngIf="loader">
        <div class="lobby_group--header-skelton animated-background"></div>
        <div class="slots_card col-md-2" *ngFor="let game of [].constructor(6)">
            <app-lobby-game-card [game]="'game'" [skelton_loaders]='true'></app-lobby-game-card>
        </div>
    </div>

    <ng-container *ngIf="!showAllGames && !showAllProviders && !loader">
        <ng-container *ngFor="let gameGroup of currentGameGroupsList; let groupIndex = index">
                        <!-- groupIndex{{groupIndex}}
            currentGameGroupsList{{currentGameGroupsList.length}} -->
            <div class="lobby_group--parent"
                [ngClass]="gameGroup.game_asset_style === 'column' && showSwiper ? 'game_card--rect' : gameGroup.game_asset_style === 'sqaure' && showSwiper ? 'square' : ''" *ngIf="gameGroup.game_asset_style != 'expanded' && gameGroup.game_asset_style != 'quicklink'">
             
                 <!-- Latest Played games -->
                 <ng-container *ngIf="gameGroup.group_sub_type === 'continue_playing' && isUserLoggedIn && !showSwiper">
                    <ng-container *ngIf="lastPlayedGamesArray && lastPlayedGamesArray.length">
                        <div class="last_played--row clearfix">
                            <ng-container *ngFor="let game of lastPlayedGamesArray">
                                <div class="slots_card col-md-2"    
                                    *ngIf="(game.gameType === 'live_casino' && liveTableData[game.pristineGameId]) || game.gameType !== 'live_casino'">
                                    <div class="slot_rect_card">
                                        <app-lobby-game-card [game]="game" [isFavourite]="isFavGameCheck[game.gameCode]"
                                            [liveGameDetails]="liveTableData[game.pristineGameId]"></app-lobby-game-card>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="gameGroup.group_sub_type === 'continue_playing' && isUserLoggedIn && showSwiper && lastPlayedGamesArray && lastPlayedGamesArray.length" >
                    <app-lobby-swiper [disableViewMore]="true" [favItemObj]="isFavGameCheck" [currentLobby]="currentLobby" [gameGroup]="gameGroup" [gameGroupDetails]="lastPlayedGamesArray" [liveTableData]="liveTableData"></app-lobby-swiper>
                </ng-container>
                <!-- Latest Played games end -->

                <!-- Favourite games -->
                
                <ng-container *ngIf="gameGroup.group_sub_type === 'favourite' && isUserLoggedIn && !showSwiper " >
                    <ng-container *ngIf="favItemObj && favItemObj.length">
                        <div class="last_played--row clearfix">
                            <ng-container *ngFor="let game of favItemObj">
                                <div class="slots_card col-md-2"
                                    *ngIf="(game.gameType === 'live_casino' && liveTableData[game.pristineGameId]) || game.gameType !== 'live_casino'">
                                    <div class="slot_rect_card">
                                        <app-lobby-game-card [game]="game" [isFavourite]="true"
                                            [liveGameDetails]="liveTableData[game.pristineGameId]"></app-lobby-game-card>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                </ng-container>
                <!-- <ng-container *ngIf="gameGroup.group_sub_type === 'favourite' && isUserLoggedIn && showSwiper " >
                    <ng-container *ngIf="favItemObj && favItemObj.length">
                    
                        <div class="lobby_group--header" [ngClass]="showSwiper ? 'swiper_header' : ''">
                            <h4 class="lobby_group--title">{{gameGroup.name}}</h4>
                            <a class="site-btn lobby_group--button" routerLink="{{goToCategory(gameGroup)}}" >
                                {{'gamingComp.gaming30' | translate}}
                            </a>
                        </div>
                        <ng-container *ngIf="showSwiper && favItemObj">
                            <swiper class="lobby_group--games mySwiper swiper-control clearfix"
                                [config]="gameGroup.game_asset_style != 'column' ? swiperColumnConfig : swiperDefaultConfig">
                                <ng-template swiperSlide *ngFor="let game of favItemObj | slice:start:end">
                                    <div class="swiper_card"
                                        *ngIf="(game.gameType === 'live_casino' && liveTableData[game.pristineGameId]) || game.gameType !== 'live_casino'">
                                        <div>
                                            <app-lobby-game-card [game]="game" [isFavourite]="isFavGameCheck[game.gameCode]"
                                                [liveGameDetails]="liveTableData[game.pristineGameId]">
                                            </app-lobby-game-card>
                                        </div>
                                    </div>
                                </ng-template>
                            </swiper>
                        </ng-container>
                    </ng-container>
                </ng-container> -->
                <ng-container *ngIf="gameGroup.group_sub_type === 'favourite' && isUserLoggedIn && showSwiper && favItemObj && favItemObj.length" >
                    <app-lobby-swiper [favItemObj]="isFavGameCheck" [currentLobby]="currentLobby" [gameGroup]="gameGroup" [gameGroupDetails]="favItemObj" [liveTableData]="liveTableData"></app-lobby-swiper>
                </ng-container>
                 <!-- Favourite games ended -->

                <!-- <div class="lobby_group--header" *ngIf="showSwiper && gamesGroupedByGameGroup[gameGroup.id]"
                    [ngClass]="showSwiper ? 'swiper_header' : ''">
                    <h4 class="lobby_group--title">{{gameGroup.name}}</h4>
                    <a class="site-btn lobby_group--button" routerLink="{{goToCategory(gameGroup)}}" *ngIf="gameGroup.game_asset_style !== 'column'">
                        {{'gamingComp.gaming30' | translate}}
                    </a>
                </div> -->

                <!-- Swiper -->
                <!-- <ng-container swiperSlide *ngIf="showSwiper && gamesGroupedByGameGroup[gameGroup.id]">
                    <div class="container-game-group">
                        <div class="container">
                          <div class="row">
                            <div class="lobby_group--games swiper swiper-control clearfix"
                            [config]="gameGroup.game_asset_style === 'column' ? swiperColumnConfig : swiperDefaultConfig">
                                    <div class="swiper-wrapper">
                                        <ng-template *ngFor="let game of gamesGroupedByGameGroup[gameGroup.id] | slice:start:end">
                                            <div class="swiper-slide"
                                                *ngIf="(game.gameType === 'live_casino' && liveTableData[game.pristineGameId]) || game.gameType !== 'live_casino'">
                                                <div class="slot_rect_card">
                                                    <app-lobby-game-card [game]="game" [isFavourite]="isFavGameCheck[game.gameCode]"
                                                        [liveGameDetails]="liveTableData[game.pristineGameId]">
                                                    </app-lobby-game-card>
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </ng-container> -->

                <ng-container *ngIf="showSwiper && gamesGroupedByGameGroup[gameGroup.id]" >
                    <app-lobby-swiper [favItemObj]="isFavGameCheck" [currentLobby]="currentLobby" [gameGroup]="gameGroup" [gameGroupDetails]="gamesGroupedByGameGroup[gameGroup.id]" [liveTableData]="liveTableData"></app-lobby-swiper>
                </ng-container>

                <!-- Show Lobby selected All Games -->
                <div class="lobby_group--row" *ngIf="!showSwiper && gamesGroupedByGameGroup[gameGroup.id]">
                    <ng-container *ngFor="let game of gamesGroupedByGameGroup[gameGroup.id] | slice:start:end">
                        <div class="slots_card col-md-2"
                            *ngIf="(game.gameType === 'live_casino' && liveTableData[game.pristineGameId]) || game.gameType !== 'live_casino'">
                            <div class="slot_rect_card">
                                <app-lobby-game-card [game]="game" [isFavourite]="isFavGameCheck[game.gameCode]"
                                    [liveGameDetails]="liveTableData[game.pristineGameId]">
                                </app-lobby-game-card>
                            </div>
                        </div>
                    </ng-container>
                </div>
                <ng-container *ngIf="(!showSwiper && !gamesGroupedByGameGroup[gameGroup.id] && gameGroup.group_sub_type != 'favourite' && gameGroup.group_sub_type != 'continue_playing' && !isLoadingLastPlayedGames) ||(gameGroup.group_sub_type === 'favourite' && !favItemObj.length && !showSwiper) || (gameGroup.group_sub_type === 'continue_playing' && !lastPlayedGamesArray?.length && !showSwiper && !isLoadingLastPlayedGames)">
                    <div class="slot_games--wrap slotsContentBlock">
                        <p class="no-games">{{'gamingComp.gaming24' | translate}}</p>
                    </div>
                </ng-container>
            </div>

            <!--Single Game Lobby code-->
                 <div *ngIf="gameGroup.game_asset_style === 'expanded' && gamesGroupedByGameGroup[gameGroup.id]">
                    <div class="single-gc__lobby">
                        <div class="single-gc__lobby--header lobby_group--header">
                            <h2 class="lobby_group--title">{{gameGroup.name}}</h2>
                        </div>
                        <div class="single-gc__lobby--body">
                            <div class="single-gc--row">
                               <div class="single-gc--img-wrap" style="background-image:url('{{siteUrlPath}}/{{mediaPath}}/games/expanded/single-gc-bg.png')">
                                    <div class="single-gc--img-wrap-card">
                                        <!-- <img src="../../../assets/img/single-gc-img.png" alt=""> -->
                                        <img src="{{siteUrlPath}}/{{mediaPath}}/games/expanded/{{getGameId(gameGroup)}}.png" alt="Single-gc-image">
                                    </div>
                                </div>
                                <div class="single-gc--content">
                                    <div class="single-gc--info">
                                        <h3 class="single-gc--prov">{{gamesGroupedByGameGroup[gameGroup.id][0].vendorDisplayName}}</h3>
                                        <h1 class="single-gc--title">{{gamesGroupedByGameGroup[gameGroup.id][0].name}}</h1>
                                        <div class="single-gc--gamegroup-content" [innerHtml]="gameGroup.content | safeHtml"></div>
                                    </div>
                                    <div class="single-gc__btns">
                                        <button class="btn site-btn--lg site-btn__primary single-gc--playbtn" *ngIf="isUserLoggedIn" (click)="gameLauncher('real',gamesGroupedByGameGroup[gameGroup.id][0])">{{'gamingComp.playNow' | translate}}</button>
                                        <button class="btn site-btn--lg site-btn__primary single-gc--playbtn" *ngIf="gamesGroupedByGameGroup[gameGroup.id][0].hasDemo > 0 && !isUserLoggedIn" (click)="gameLauncher('demo',gamesGroupedByGameGroup[gameGroup.id][0])">{{'gamingComp.gaming23' | translate}}</button>
                                        <i class="icon slots_card--fav icon-heart" 
                                            *ngIf="isUserLoggedIn"
                                            [ngClass]="isFavGameCheck[gamesGroupedByGameGroup[gameGroup.id][0].gameCode] ? 'slots_card--fav-selected' : ''" (click)="setFavouriteGames(gamesGroupedByGameGroup[gameGroup.id][0].gameCode)">
                                        </i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            <!--ends here-->
            
            <!-- <ng-container *ngIf="((currentGameGroupsList.length >= 3) && (groupIndex === 2)) || ((currentGameGroupsList.length < 3) && (groupIndex === currentGameGroupsList.length-1))" > -->
            <ng-container *ngIf="gameGroup.group_sub_type == 'provider' && gameGroup.game_asset_style == 'quicklink'" >
    
                <!-- <ng-container *ngFor="let providerGroup of objectKeys(providerGroups)"> -->
                <!-- Game Category By Providers -->
                <div class="lobby_group--game-providers lobby_group--parent clearfix" *ngIf="providerGroups[gameGroup.id]">
                    <!-- <div class="lobby_group--header" *ngIf="showSwiper "
                        [ngClass]="showSwiper ? 'swiper_header' : ''">
                        <h4 class="lobby_group--title">{{'gamePlayCategories.gamesProvidersHeading' | translate}}</h4>
                        <a class="site-btn lobby_group--button" routerLink="{{'/'+langCode+'/casino/game-providers'}}">
                            {{'gamingComp.gaming30' | translate}}
                        </a>
                    </div> -->
                    <app-game-providers [allProvidersPage]="false" [providerGroupName]="gameGroup.name" [gameProviderMap]="providerGroups[gameGroup.id]"></app-game-providers>
                </div>
                <!-- </ng-container>     -->
            </ng-container>
        </ng-container>


        <ng-container *ngIf="!currentGameGroupsList">
            <div class="main-pages_loader loading-div">
                <div class='loader loader-large'></div>
            </div>
        </ng-container>

        <ng-container *ngIf="currentGameGroupsList && currentGameGroupsList.length === 0">
            <div class="slot_games--wrap slotsContentBlock">
                <p class="no-games">{{'gamingComp.gaming24' | translate}}</p>
            </div>
        </ng-container>
    </ng-container>

    <!-- Show All Games -->
    <div class="lobby_group--parent" *ngIf="showAllGames && !showAllProviders && !loader">
        <!-- <div class="lobby_group--header" *ngIf="showSwiper" [ngClass]="showSwiper ? 'swiper_header' : ''">
            <h4 class="lobby_group--title"></h4>
        </div> -->

        <div class="lobby_group--row">
            <app-lobby-game-result-page [favItemObj]="isFavGameCheck" (lobbyTitle)="getBannerTitle($event)"
                [gameGroupDetails]="gameGroupDetails" [liveTableData]="liveTableData"></app-lobby-game-result-page>
        </div>
    </div>

    <!-- Show All Providers -->
    <div class="lobby_group--parent" *ngIf="!showAllGames && showAllProviders && !loader">
        <div class="lobby_group--row">
            <app-game-providers [allProvidersPage]="true" [gameProviderMap]="gameProviderMap"></app-game-providers>
        </div>
    </div>

    <ng-container *ngIf="(currentGameGroupsList && (currentGameGroupsList.length === 0) && !showAllGames && !showAllProviders && gameProviderMap && !loader)">
        <!-- Game Category By Providers -->
        <div class="lobby_group--game-providers lobby_group--parent clearfix">
            <div class="lobby_group--header" *ngIf="showSwiper "
                [ngClass]="showSwiper ? 'swiper_header' : ''">
                <h4 class="lobby_group--title">{{'gamePlayCategories.gamesProvidersHeading' | translate}}</h4>
                <!-- <a class="site-btn lobby_group--button" routerLink="{{'/'+langCode+'/casino/game-providers'}}">
                    {{'gamingComp.gaming30' | translate}}
                </a> -->
            </div>
            <app-game-providers [allProvidersPage]="false" [gameProviderMap]="gameProviderMap"></app-game-providers>
        </div>
    </ng-container>

    <!-- Game Category By theme -->
    <!-- <div class="lobby_group--game-themes lobby_group--parent clearfix" *ngIf="tagsList && !loader">
        <div class="lobby_group--header swiper_header">
            <h4 class="lobby_group--title">{{'gamePlayCategories.gamesCategoryHeading' | translate}}</h4>
        </div>
        <app-lobby-game-by-theme [activeTag]="tagId" [tagsList]="tagsList"></app-lobby-game-by-theme>
    </div> -->

    <!-- View all games CTA -->
    <div class="lobby_group--btn-group" *ngIf="showSwiper && !showAllGames && !showAllProviders && !loader">
        <a class="site-btn site-btn__primary site-btn--lg" routerLink="{{'/'+langCode+'/casino/allgames'}}">{{'gamingComp.gaming25' |
            translate}} </a>
    </div>
    <app-carousel-banner *ngIf="seoBannerContentVal && gameGroupFromParams!='allgames'" [seoBannerContent]="seoBannerContentVal"></app-carousel-banner>
</div>